<template>
  <div class="homeArticle HomeContainer">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/home">{{ l("首页") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ l("行情中心") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="mainContainer">
      <Tabs
        style="margin-top: 10px; margin-bottom: 15px"
        :list="tabList"
        item_width="120px"
        v-model="SearchData.type"
        @tab-click="GetTableList(true)"
      ></Tabs>
      <router-link
        v-for="item of TableList"
        :key="item.id"
        :to="{ path: '/home/article/detail/' + item.id }"
        class="articleCard"
      >
        <el-image
          :src="item.cover_url || GetResourceUrl('default.jpg')"
          fit="cover"
        ></el-image>
        <div class="textContent">
          <div class="title one_lines">
            {{ item.title }}
          </div>

          <div class="content one_lines">
            {{ item.content }}
          </div>
          <div class="time_btn">
            <div class="time">
              <i class="el-icon-time"></i>
              {{ item.custom_created_time }}
            </div>
            <div class="btn">{{ l("阅读全文") }}>></div>
          </div>
        </div>
      </router-link>

      <el-empty
        v-if="!TableList.length"
        :description="l('暂无内容')"
      ></el-empty>
    </div>

    <el-pagination
      v-if="TableList.length"
      style="justify-content: center; margin-top: 35px"
      background
      @current-change="HandleCurrentChange"
      :current-page="CurrentPage"
      :page-size="PageSize"
      layout="total, prev, pager, next, jumper"
      :total="TotalCount"
    ></el-pagination>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";

export default {
  name: "HomeArticle",
  mixins: [tableMixin],
  data() {
    return {
      PageSize: 6,
      Sorting: "-order_index",
      SearchData: {
        group: 2,
        type: "",
      },
      tabList: [
        {
          label: this.l("全部"),
          value: "",
        },
        {
          label: this.l("动态"),
          value: "动态",
        },
        {
          label: this.l("聚焦"),
          value: "聚焦",
        },
        {
          label: this.l("解读"),
          value: "解读",
        },
        {
          label: this.l("周评"),
          value: "周评",
        },
      ],
    };
  },
  created() {
    this.SearchData.type = this.$route.query.type || "";
  },
  mounted() {},
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get("/api/article/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    selectType(target) {
      this.$router.push({
        path: `/home/article/${target}`,
      });
    },
  },
};
</script>


<style scoped lang="scss">
.homeArticle {
  margin-top: 15px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 30px;
    /deep/.el-breadcrumb__inner.is-link {
      font-weight: normal;
    }
  }
  .mainContainer {
    background: #fff;
    box-sizing: border-box;
    padding: 10px 50px 20px;
    margin-top: 15px;

    .articleCard {
      background: #fff;
      display: flex;
      justify-content: space-between;
      padding: 30px 0;
      box-sizing: border-box;
      cursor: pointer;
      & + .articleCard {
        border-top: 1px solid $borderPlainColor;
      }
      .el-image {
        width: 128px;
        height: 96px;
        flex-shrink: 0;
      }
      .textContent {
        width: 938px;
        height: 96px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .title {
          font-size: 18px;
          height: 25px;
          line-height: 25px;
        }

        .content {
          color: #666;
        }

        .time_btn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .time {
            color: #666;
          }
          .btn {
            color: $linkColor;
          }
        }
      }

      // &:hover .title {
      //   color: $warningColor;
      // }
    }
  }
}
</style>

